<div id="onboarding-component" class="component-inner-wrapper onboarding-component-class">
    <main class="main-content">
        <div class="container">
            <div class="breadcrumb">
                <span>ONBOARDING</span>
                <span>></span>
                <a class="ele_link" (click)="navigateToOnboarding()">Upload Devices</a>
            </div>
            <h1 class="page-title">Upload Devices</h1>
            <div class="content-wrapper ">
                <div class="upload-section container-sections" [ngStyle]="{ 'padding-bottom': '0px' }">
                    <p class="paraStyle">Select the customer and group for the devices you are uploading.</p>
                    <form id="uploadForm">
                      <div class="form-horizontal">
                        <div class="form-group">
                          <label class="form-label">Customer<span class="text-danger">*</span></label>
                          <select class="form-select" (change)="onCustomerChange($event)" name="customer">
                            <option value="">{{ customerDropdownSelectLabel }}</option>
                            <option *ngFor="let customer of customers" [value]="customer.id">{{ customer.customerName }}</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label class="form-label">Group<span class="text-danger">*</span></label>
                          <select class="form-select" [disabled]="isGroupDropdownDisabled" [ngModel]="selectedGroup" (change)="onGroupChange($event)" name="group">
                            <option value="">{{ groupDropdownEmptyLabel }}</option>
                            <option *ngFor="let group of groups" [value]="group.id">{{ group.groupName }}</option>
                          </select>
                        </div>
                      </div>
                      <div
                      #uploadArea
                      class="upload-area"
                      (click)="triggerFileInput()"
                      (dragover)="onDragOver($event)"
                      (dragleave)="onDragLeave()"
                      (drop)="onFileDrop($event)"
                      [style.borderColor]="borderColor"
                       [class.disabled]="!selectedCustomer || !selectedGroup"
                       [class.pointer-events-none]="!selectedCustomer || !selectedGroup"
                    >
                    <span class="material-symbols-outlined upload-icon">
                      cloud_download
                      </span>
                    <p style="font-size: small;">Drag&Drop file here</p>
                    <button type="button" class="btn btn-confirm" [disabled]="!selectedCustomer || !selectedGroup">Choose file</button>
                      <p class="upload-text">{{ uploadText }}</p>
                    </div>
                    <input
                      #fileInput
                      type="file"
                      class="file-input"
                      (change)="onFileInputChange($event)"

                    />
                    </form>

                </div>
                <div *ngIf="hideShowErrSuccess" class="status-section container-sections">
                  <div class="status-container">
                    <h2 class="section-subtitle">Device Processing Status
                      <p ></p>
                    </h2>
                    <div class="save-results-section" *ngIf="(successCount!=0 && failureCount!=0) || (failureCount!=0 || err400Key!='')">
                      <button class="button-download" (click)="downloadSavedLogs()">
                        <span class="button-icon"><mat-icon>cloud_download</mat-icon></span>
                        <span class="button-text">SAVE RESULTS</span>
                      </button>
                    </div>
                  </div>
                  <div class="status-section-container">
                    <div class="status-message-section">
                        <h3 class="success" *ngIf="successCount != 0">Success</h3>

                            <p *ngIf="successCount != 0">
                              <span class="status-item status-value">
                                <span  [ngClass]="'bold-text'">{{successCount}}</span>
                                &nbsp;device(s) uploaded successfully
                              </span>
                            </p>


                      </div>
                        <!-- <p class="status-item"><span class="status-title">2034</span> device uploaded successfully</p> -->
                        <div class="status-message-section" *ngIf="totalWarnings!=0">
                          <h3 class="warning">Warnings</h3>
                          <div class="status-item" *ngFor="let war of warningsKeyValue">
                                <span [ngClass]="'bold-text'">{{ war.key }}:&nbsp;</span>
                                <span>{{war.value}}</span>
                          </div>

                        </div>

                    <!--  Please follow Only this HTML structure to show error messages
                    <div class="status-message-section">
                      <h3 class="warning">Warnings</h3>
                       <p class="status-item">
                          <span class="status-title">00008F2721FB:</span>
                          <span class="status-value"> Could not be added to IoTHub.</span>
                        </p>
                    </div> -->

                    <div class="status-message-section" *ngIf="failureCount!=0">
                      <h3 class="error">Errors</h3>
                      <div class="error-item status-item" *ngFor="let error of errorKeyValue">
                        <span [ngClass]="'bold-text'">{{ error.key }}:&nbsp;</span>
                        <span>{{ error.value }}</span>
                      </div>

                      <!-- <p class="status-item"><span class="status-title">00008F2721FB:</span> Could not be added to IoTHub.</p>
                      <p class="status-item"><span class="status-title">00003E7205FF:</span> Could not be added to IoTHub or OptIO.</p> -->

                      <!-- <p class="status-item" *ngIf="err?.error">
                        <span class="status-title">{{err400Key}}</span> {{err400Value}}
                      </p> -->
                    </div>
                    <div class="status-message-section" *ngIf="err400Key!=''">
                      <h3 class="error">Errors</h3>

                          <div class="error-item" *ngIf="err?.error">
                            <div class="status-item">
                              <span  [ngClass]="'bold-text'">{{err400Key}} : &nbsp;</span><span>{{err400Value}}</span>
                            </div>

                          </div>

                    </div>
                    <div class="reupload-actions">
                      <button type="button" class="btn btn-confirm" (click)="reuploadCorrectedFile()">
                        Re-upload Corrected File
                      </button>
                    </div>
                  </div>
                </div>
            </div>
            <span class="dropbox-text">
              <p *ngIf="hideCsvTemp"> <span class="text-danger">*</span><a (click)="downloadExcelFile()">XLSX template</a>&nbsp;for uploading device data </p>
            </span>
            <button *ngIf="showUploadButton" type="button" class="btn btn-confirm" (click)="uploadFile()" [disabled]="!selectedCustomer || !selectedGroup || !isFileUploaded">Upload file</button>
        </div>
    </main>
</div>



